import React from 'react'

// import TracerNavbar from '../../Component/Navbar/TracerNavbar';
import TracerMainHeader from '../../TracerComponents/MainHeader/TracerMainHeader';
// import TracerSidebar from '../../Component/Sidebar/TracerSidebar';
// import Footer from '../../Component/Footer/Footer'
const TracerNano = () => {
  return (
    <div>
    
   <TracerMainHeader/>
  </div>
  )
}

export default TracerNano;